export function isTimeRangeOverlapping(
    range1: [number, number],
    range2: [number, number]
): boolean {
    return range1[0] <= range2[1] && range2[0] <= range1[1];
}
